import { LocalStorage } from '@plandok/core'

import { Language } from '../languages'
import { getLabelByIsoCode } from './'

export const getLanguageFromUrl = () => {
   const prefix = window.location.pathname.split('/')[1]
   return Object.values(Language).includes(prefix) ? prefix : Language.ENG
}

export const getInitialLanguage = () => {
   const appContext = LocalStorage.getAppContext()
   if (appContext) {
      return getLabelByIsoCode(appContext?.languageIsoCode)
   }
   return getLanguageFromUrl()
}

export const formatDurationWithTranslations = (h: string, min: string) => (duration: number) => {
   const hours = Math.floor(duration / 60)
   const minutes = duration % 60

   if (!hours && !minutes) {
      return `0${min}`
   }
   return (hours ? `${hours}${h}` : '').concat(minutes ? ` ${minutes}${min}` : '')
}
